import { ManageTable, type ManageField } from '@/components/ManageTable'
import { CodeEditor } from '@/components/CodeEditor'

export default function Strategy() {
  const fields: ManageField[] = [
    {
      desc: '名称',
      field: 'name',
    },
    {
      desc: '代码',
      field: 'code',
      Comp: <CodeEditor language="python" />,
      NoShowInTable: true,
    },
    {
      desc: '更新时间',
      field: 'update_time',
    },
  ]

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">策略管理</h1>
      <ManageTable fields={fields} collect="strategy" modalWidth="80%" />
    </div>
  )
}
